<div class="cpp-add-prod addProductEA" (window:resize)="onresize($event)">
  <h3>Add Product(s) to the Early Advantage Order</h3>

  <div class="form-sec">
    <div class="row md-mr-0">
      <div class="col-md-10 col-lg-12 smallPadRgt0">
        <app-cppfilter [filters]="filterTypeList" (SearchFilter)="filterProductGridData($event)" (ClearFilter)="clearGridData($event)"></app-cppfilter>
      </div>
    </div>
    <div class="text-center diclaimermsg">{{this.disclaimerMessage}}</div>
  </div>
  <div class="row">
    <div class="col-md-12 padding-t10">

      <div class="tableContainer prodTableContainer table-mobile">
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
          <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
            <div *ngIf="column=='checkbox'">
            <th mat-header-cell *matHeaderCellDef class="checkBoxCol">
              <div class="mobile-box pl-2" *ngIf="productAllDataSource && productAllDataSource.data.length > 0 && isShowSelectAllBox">
                <mat-checkbox #CheckAll [checked]=" "
                              (change)="selectAllProduct()"
                              class="custom-checkbox"></mat-checkbox>
              </div>
            </th>
      </div>
      <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name</th></div>
      <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th></div>
      <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Quantity</th></div>
      <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="orderUOMBlock text-center">Order UOM</th></div>
      <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="pricingBlock text-center">Product Line</th></div>
      <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="package text-center">Package Size</th></div>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol d-flex" matTooltip="Select Product" [matTooltipPosition]="'above'">
          <div class="mobile-box">
            <mat-checkbox #SingleCheck [checked]="element.IsProductSelected"
                          [class.mat-checkbox-disabled]="element.showError" [disabled]="element.showError"
                          (change)="selectProduct(element)"
                          (click)="showError(element)"
                          class="custom-checkbox"></mat-checkbox>
          </div>
        </div>

        <div *ngIf="column=='product'" class="order-info-outer dd-flex">
          <div class="d-block d-sm-block d-md-none xs-large-font">Product</div>
          <div class="order-info xs-large-font">
            <p>{{element.itemVendorName}}</p>
            <p class="grower-name">{{element.itemDescription}}</p>
            <!-- US 102336 - Hide for now , need to show after change the logic-->
            <div *ngIf="false">
              <p><span class="growerUnit" *ngIf="plAccess == true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUOM}}</span></p>
              <p><span class="paymentTerm" *ngIf="element.paymentTerms!='' && element.paymentTerms!=null && element.paymentTerms!=undefined">{{element.paymentTerms }}</span></p>
            </div>
            <p class="grower-name" style="color: #eb6666 !important " *ngIf="element.invalidProductMessage!='' && element.invalidProductMessage!=null && element.invalidProductMessage!=undefined">{{element.invalidProductMessage}}</p>
          </div>

          <span class="favIcon position-relative" *ngIf="element.warningMessage">
            <i class="warning-icon" mat-raised-button
               matTooltip="{{element.warningMessage}}"
               [matTooltipPosition]="'above'" matTooltipClass='red-tooltip'></i>
          </span>
        </div>
        <div *ngIf="column=='detail'" class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);">
          <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
        </div>
        <div *ngIf="column=='quantity'" class="quantityBlock text-center largeTableTxt landscape-miw-101">
          <div class="d-block d-sm-block d-md-none">QTY</div>
          <div class="xs-ml-20 md-ml-0">
            <button *ngIf="!readOnlyAccess" class="plus-minus-btn minusBtn" [ngStyle]="element.isValidItem ? {'visibility': 'visible'} : {'visibility': 'hidden'}" (click)="orderUnitChange('decrease',element)"> - </button>
            <input [readonly]="readOnlyAccess" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.quantity<=0 || element.quantity=='')}" />
            <button *ngIf="!readOnlyAccess" class="plus-minus-btn plusBtn" [ngStyle]="element.isValidItem ? {'visibility': 'visible'} : {'visibility': 'hidden'}" (click)="orderUnitChange('increase',element)"> + </button>
          </div>
        </div>
        <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt">
          <!-- <div class="d-block d-sm-block ">UOM CA</div> -->
          {{element.uom}}
        </div>
        <div *ngIf="column=='productLine'" class="measureUnit largeTableTxt text-center  largeTableTxt mobile-col-set">
          <div class="d-block d-sm-block  d-md-none">Product Line</div>
          <div class="m-center">{{element.productLine}}</div>
        </div>
        <div *ngIf="column=='packageSize'" class="measureUnit largeTableTxt text-center largeTableTxt mobile-col-set">
          <div class="d-block d-sm-block  d-md-none">Package Size</div>
          <div class="m-center"> {{element.packageSize}}</div>
        </div>
      </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div [style.display]="element.isSelected ? 'block' : 'none'">
            <div class="cpp-prod-info mobile-nested-table">
              <table style="width:100%" class="m-0">
                <thead>
                  <tr>
                    <th width="10%" class="text-left">Item # </th>
                    <th width="13%"> GTIN </th>
                    <th width="13%"> Product Line </th>
                    <th width="20%"> Active Ingredients </th>
                    <!--<th width="10%"> National Price </th>-->
                    <th width="13%"> Pallet Quantity </th>
                    <th width="13%"> Restricted Use </th>
                    <th width="13%"> Non-Returnable </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="">
                    <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>
                    <td width="10%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                    <th width="13%" class="d-block d-sm-block d-md-none"> GTIN </th>
                    <td width="13%"><p>{{element.gtin}}</p></td>
                    <th width="13%" class="d-block d-sm-block d-md-none"> Product Line </th>
                    <td width="13%"> <p>{{element.productLine}}</p> </td>
                    <th width="20%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                    <td width="20%"><p>{{element.activeIngredient}}</p> </td>
                    <!--<th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>
                    <td width="10%"> <p> {{element.price | number:'1.4-4'}}</p> </td>-->
                    <th width="13%" class="d-block d-sm-block d-md-none"> Pallet Quantity </th>
                    <td width="13%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                    <th width="13%" class="d-block d-sm-block d-md-none"> Restricted Use </th>
                    <td width="13%"><p>{{element.restrictedUse}}</p> </td>
                    <th width="13%" class="d-block d-sm-block d-md-none"> Non-Returnable </th>
                    <td width="13%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"><p>{{element.returnable}}</p></div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="inline-error red-inline-error" *ngIf="element.showError && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
            <div class="row">
              <div class="col-md-10">
                <ol class="error-list">
                  <li *ngFor="let err of element.lineErrors.errors">
                    {{err.error}}
                </ol>
              </div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"
          class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          (click)="expandedElement = expandedElement === element ? null : element" [ngClass]="element.isValidItem ? '' : 'backgroundDisable'"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </table>
    </div>
  </div>
</div>
</div>
<div class="row add-order-sec margin-l0 margin-r0">
  <div class="col-md-6 xs-pl-0 xs-pr-0">
    <button mat-raised-button class="btns xs-button xs-full-width margin-r15" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
    <button mat-raised-button class="btns xs-button xs-full-width" color="primary" [disabled]="productAllDataSource && productAllDataSource.data.length == 0" (click)="exportProducts()">Export</button>
  </div>
  <div class="col-md-6 text-right xs-text-center xs-mt-10 md-mt-0">
    <span class="count d-none d-sm-none d-md-block"> Products Selected <span>{{selectedProductList.length}}</span></span>
    <span class="count d-none d-sm-none d-md-block"> Products With Errors <span class="red-error">{{errorCount}}</span></span>
  </div>
</div>
